function formatNumber(n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}

export function formatTime(date) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  const t1 = [year, month, day].map(formatNumber).join('/')
  const t2 = [hour, minute, second].map(formatNumber).join(':')

  return `${t1} ${t2}`
}


export function FormatTime(timestamp) {
  var time = new Date() - timestamp // 时间差

  if (time / 1000 < 60) {
    return '刚刚';
  }

  if (Math.floor(time / 1000 / 60) < 60) {
    return `${Math.floor(time / 1000 / 60)}分钟前`;
  }

  if (Math.floor(time / 1000 / 60 / 60) < 24) {
    return `${Math.floor(time / 1000 / 60 / 60)}小时${Math.floor(
       (time / 1000 / 60) % 60
     )}分前`;

  }

  if (Math.floor(time / 1000 / 60 / 60 / 24) == 1) {
    return `昨天`;
  }

  if (Math.floor(time / 1000 / 60 / 60 / 24) == 2) {
    return `前天`;
  }

  if (Math.floor(time / 1000 / 60 / 60 / 24) < 31) { // 加一个判断
    return `${Math.floor(time / 1000 / 60 / 60 / 24)}天前`;
  }

  // 转化成-月-日
  if (Math.floor(time / 1000 / 60 / 60 / 24) < 365) {
    var curDate = new Date() // 当前时间

    var pushDate = new Date(timestamp) // 发布时间
    if (pushDate.getFullYear() === curDate.getFullYear()) { // 判断是否跨年
      var month = pushDate.getMonth() + 1 >= 10 ? pushDate.getMonth() + 1 : `0${pushDate.getMonth()+1}`
      var day = pushDate.getDate() // 这里不需要判断，返回的就是1-31
      return `${month}月${day}日`
    } else {
      var year = pushDate.getFullYear()
      var month = pushDate.getMonth() + 1 >= 10 ? pushDate.getMonth() + 1 : `0${pushDate.getMonth()+1}`
      var day = pushDate.getDate()
      return `${year}年${month}月${day}日`;
    }

  }
// 转化成-年-月-日
  if (Math.floor(time / 1000 / 60 / 60 / 24) > 365) {

    var pushDate = new Date(timestamp) // 发布时间

    var year = pushDate.getFullYear()
    var month = pushDate.getMonth() + 1 >= 10 ? pushDate.getMonth() + 1 : `0${pushDate.getMonth()+1}`
    var day = pushDate.getDate()
    return `${year}年${month}月${day}日`;
  }


}
export function FormDate(time) {
  let str = time;
  let regTimes = []
  if (str) {
    regTimes = str.split('-')
    if (regTimes.length === 3) {
      let year = regTimes[0]
      let month = regTimes[1]
      let date = regTimes[2]
      month = month.replace(/^0/, '')
      date = date.replace(/^0/, '')
      return month + '.' + date 
    }
  }
  return ''
}
export default {
  FormatTime, //……前格式
  formatNumber,
  formatTime ,//年月日 时分秒格式
  FormDate,//月日
}


// WEBPACK FOOTER //
// ./src/assets/js/time.js